export default {"src":"//_next/static/media/spade.5303c7cd.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};